import { Slide } from '@features/powerpoint';
import { BuildPresentationProps } from './build-presentation';
import { executiveSummarySlide } from '../../../slides';
import { NEWLINE_REGEX } from '../../../domain/key-takeaways';

export const executiveSummarySlideFromProps = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] =>
  props.customFields.includedSlides.overall.executiveSummary
    ? [
        executiveSummarySlide({
          slideMaster,
          rsaKeyTakeaways: props.customFields.rsaSummary.split(NEWLINE_REGEX),
          ftaKeyTakeaways: props.customFields.ftaSummary.split(NEWLINE_REGEX),
        }),
      ]
    : [];
